
// SVG Icon: edit-story
export default { id: "terriajs-edit-story" };
export const id = "terriajs-edit-story";
export const name = "edit-story";
